import { setPageGroupData } from "../../../features/pageGroupSlice";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { pageGroupServices } from "../../../services/api/page-group.endpoints";
import store from "../../../store";

async function getAllPageGroupsDuplicate(oauthTokenHeader: string,website_shared_uid:any,dispatch:any) {
    try {
        const response = await pageGroupServices.getAllPageGroups(oauthTokenHeader,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get page content');
        }
        else {
            // setPageGroups(response?.data?.data); // Set the fetched data
            dispatch(setPageGroupData(response?.data?.data));
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function getAllPageGroups(oauthTokenHeader: string,website_shared_uid:any,setPageGroups:any) {
    try {
        const response = await pageGroupServices.getAllPageGroups(oauthTokenHeader,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get page content');
        }
        else {
            setPageGroups(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function getSinglePageGroup(oauthTokenHeader: string,website_shared_uid: any, page_shared_uid:any, setSinglePageGroup:any) {
    try {
        const response = await pageGroupServices.getSinglePageGroup(oauthTokenHeader,website_shared_uid, page_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get page content');
        }
        else {
            setSinglePageGroup(response?.data?.data[0]); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function getAllThemes(oauthTokenHeader: any,website_shared_uid:any,setThemes:any) {
    try {
        const response = await pageGroupServices.getAllThemes(oauthTokenHeader,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get themes');
        }
        else {
            setThemes(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function getAllPopups(oauthTokenHeader: any,website_shared_uid:any,setPageGroups:any) {
    try {
        const response = await pageGroupServices.getPopupOffers(oauthTokenHeader,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get popups');
        }
        else {
            setPageGroups(response?.data?.data?.widgets); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function getWebsiteAttributeDetails(oauthTokenHeader: any,website_shared_uid:any,setAttributeDetails:any) {
    try {
        const response = await pageGroupServices.getWebsiteAttributeDetails(oauthTokenHeader,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get site attribute');
        }
        else {
            setAttributeDetails(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function postImageUpload(oauthTokenHeader: any,website_shared_uid:any,setImagePath:any,data:any) {
    try {
        const response = await pageGroupServices.uploadImage(oauthTokenHeader,data,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get site attribute');
        }
        else {
            setImagePath(response?.data?.data[0]?.upload_path); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createPageGroup(oauthTokenHeader: any,website_shared_uid:any,setPageGroup:any,data:any) {
    try {
        const response = await pageGroupServices.createPageGroup(oauthTokenHeader,data,website_shared_uid);
        if (!response || !response.status || response.status !== 201) {
            throw new Error('Failed to get site attribute');
        }
        else {
            setPageGroup(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        setPageGroup([]); // Set the fetched data
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function editPageGroup(oauthTokenHeader: any, website_shared_uid: any, page_group_uid: any, data: any, setUpdatedPageGroupData: any) {
    try {
        const response = await pageGroupServices.editPageGroup(oauthTokenHeader, data, website_shared_uid, page_group_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get site attribute');
        }
        else {
            // Set the fetched data
            setUpdatedPageGroupData(response?.data?.data);
        }
    } catch (e: any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

export const PageGroupEndPointLogic = {getAllPageGroups,getSinglePageGroup,getAllThemes,getAllPopups,getWebsiteAttributeDetails,postImageUpload,createPageGroup,editPageGroup,getAllPageGroupsDuplicate};